import { NestedLegs } from 'api'
import { useMemo } from 'react'
import { NestedLegItemWithIndex } from './model'

export function useRowData<T extends { nestedLegs?: NestedLegs | null }>(data: T | undefined | null): NestedLegItemWithIndex[] {
  return useMemo(() => {
    return (
      data?.nestedLegs?.legs?.map((l, i) => {
        return {
          ...l,
          index: i
        }
      }) ?? []
    )
  }, [data?.nestedLegs?.legs])
}
